export default "__VITE_ASSET__xRCaU5mt__"